import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { APGenericSlot } from '../../../../global/builders/ap_generic_slot_builder';
import { APUserModeConfig } from '../../user_mode_config/config/ap_user_mode_config';
import { MarkAsMetSlotModel } from '../models/mark_as_met_slot_model';
import { APAdvisorText } from './../../../servants/ap_advisor_text_servant';

interface IMarkAsMetDialogQuery {
  title?: string;
  description?: string;
  genericSlot?: APGenericSlot;
  reasonText?: string;
}

export class MarkAsMetDialogQuery implements IQuery {
  private __result: IMarkAsMetDialogQuery;

  constructor(
    private ngAPUserModeConfig: APUserModeConfig,
    private ngMarkAsMetSlotModel: MarkAsMetSlotModel,
    private ngAPAdvisorText: APAdvisorText,
    private phxFeatureConfiguration: any
  ) {
    ORMMediator.registerQuery(this, ngMarkAsMetSlotModel);
  }

  run() {
    const genericSlot = this.ngMarkAsMetSlotModel.read().currentSlot;
    if (!genericSlot) {
      this.__result = {
        title: '',
        description: '',
        reasonText: '',
        genericSlot
      };
      return this;
    }
    const title = `Mark as Met: ${_4.get(genericSlot, 'title')}`;
    this.__result = {
      title,
      genericSlot,
      reasonText: `<span class="text-bold">Reason</span> (visible to student). 
            Enter the reason you are marking this requirement as met.`
    };
    const actionFor = this.ngAPUserModeConfig.isStudent() ? 'you have' : 'student has';
    this.__result.description = `You are about to mark <span class="text-bold">${genericSlot.title}</span> as met. 
            This means ${actionFor} satisfied this requirement in another way from the options identified in Navigate360. 
            Marking an item as met does not affect ${
              this.ngAPUserModeConfig.isStudent() ? 'your' : ''
            } actual program progress.`;
    if (this.ngAPUserModeConfig.isStudent()) {
      this.__result.reasonText = `<span class="text-bold">Reason</span>. Enter the reason you are marking this requirement as met.`;
      const advisorText = this.ngAPAdvisorText.advisorLabel;
      this.__result.description += `Please <schedule-appointments-link button-text="meet with your ${advisorText}" aesthetic="link"></schedule-appointments-link> to be sure that you are on track to meet the requirements for your program.`;
    }
    return this;
  }

  get result(): IMarkAsMetDialogQuery {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngMarkAsMetDialogQuery', MarkAsMetDialogQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/queries/mark_as_met_dialog_query.ts